<div class="w-full relative">
  <div class="overflow-x-auto scroll-custom rounded-2xl border border-soft-gray-outline" 
    #tableContainer
    (scroll)="onTableScroll()">
  <table class="min-w-full">
    <thead class="h-[36px] bg-light border-b border-soft-gray-outline">
      <tr>
        @for (col of columns; track $index) {
        <th scope="col"
          class="px-4 py-2 font-semibold text-[14px] text-text-primary select-none whitespace-nowrap text-ellipsis"
          [class]="col.headerClass || ''"
          [ngClass]="{
              'min-w-[100px]': $index === 0,
              'min-w-[150px] max-w-[200px]': $index !== 0,
              'overflow-visible': col.columnType === 'dateHourPicker' || col.columnType === 'multiSelectFilter' || col.columnType === 'textSearch',
              'overflow-hidden': col.columnType !== 'dateHourPicker' && col.columnType !== 'multiSelectFilter' && col.columnType !== 'textSearch'
            }">
          <div class="flex items-center justify-between" [ngClass]="{'relative': col.columnType === 'dateHourPicker' || col.columnType === 'multiSelectFilter' || col.columnType === 'textSearch'}">
            <div class="flex items-center space-x-1">
              <span class="truncate block">{{ col.label }}</span>

              @if (col.sortable && showSorting && col.columnType !== 'dateHourPicker' && col.columnType !== 'multiSelectFilter' && col.columnType !== 'textSearch') {
              <div class="flex flex-col leading-none cursor-pointer p-1 rounded hover:bg-gray-100 transition-colors"
                (click)="onSortToggle(col.key)" title="Ordenar por {{ col.label }}">
                <i class="fi-sr-caret-up text-[10px] -mb-[3px]" [ngClass]="{
                          'text-text-primary': sortColumn() === col.key && sortDirection() === 'asc',
                          'text-text-secondary': (sortColumn() !== col.key || sortDirection() !== 'asc')
                        }"></i>
                <i class="fi-sr-caret-down text-[10px] -mt-[4px]" [ngClass]="{
                          'text-text-primary': sortColumn() === col.key && sortDirection() === 'desc',
                          'text-text-secondary': (sortColumn() !== col.key || sortDirection() !== 'desc')
                        }"></i>
              </div>
              }
            </div>

            @if (col.columnType === 'dateHourPicker') {
            <div class="relative">
              <button #filterButton type="button"
                class="flex items-center justify-center w-6 h-6 p-1 rounded hover:bg-gray-100 transition-colors"
                (click)="toggleDateFilter(col.key, $event)" title="Filtrar por {{ col.label }}">
                <i class="text-[16px] leading-none" [ngClass]="{
                       'fi-sr-filter': openDateFilter === col.key || hasActiveDateFilter(col.key),
                       'fi-rs-filter': openDateFilter !== col.key && !hasActiveDateFilter(col.key)
                     }"></i>
              </button>
            </div>
            }

            @if (col.columnType === 'multiSelectFilter') {
              <button #multiFilterButton type="button"
                class="flex items-center justify-center w-6 h-6 p-1 rounded hover:bg-gray-100 transition-colors"
                (click)="toggleMultiSelectFilter(col.key, $event)" title="Filtrar por {{ col.label }}">
                <i class="text-[16px] leading-none" [ngClass]="{
                       'fi-sr-filter': openMultiSelectFilter === col.key || hasActiveFilters(col.key),
                       'fi-rs-filter': openMultiSelectFilter !== col.key && !hasActiveFilters(col.key)
                     }"></i>
              </button>
            }
            
            @if (col.columnType === 'textSearch') {
              <button #textSearchButton type="button"
                class="flex items-center justify-center w-6 h-6 p-1 rounded hover:bg-gray-100 transition-colors"
                (click)="toggleTextSearchFilter(col.key, $event)" title="Filtrar por {{ col.label }}">
                <i class="text-[16px] leading-none" [ngClass]="{
                       'fi-sr-filter': openTextSearchFilter === col.key || hasActiveTextSearch(col.key),
                       'fi-rs-filter': openTextSearchFilter !== col.key && !hasActiveTextSearch(col.key)
                     }"></i>
              </button>
            }

            @if (col.columnType === 'textSearch' && openTextSearchFilter === col.key) {
              <div
                [class]="'text-search-panel absolute top-full mt-1 z-[100] bg-white rounded-2xl min-w-[220px] animate-fadeIn overflow-hidden ' + ($last ? 'right-0' : 'left-0')"
                style="box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.16)">
                <div class="flex items-center w-full bg-white px-4 h-[46px]">
                  <i class="fi fi-rr-search text-text-secondary leading-none text-[16px] flex items-center justify-center min-w-[16px] flex-shrink-0"></i>
                  <input
                    type="text"
                    class="flex-1 outline-none font-poppins font-medium text-sm text-text-primary placeholder-text-secondary bg-white focus:outline-none truncate whitespace-nowrap overflow-hidden min-w-0 ml-2"
                    placeholder="Buscar..."
                    [ngModel]="textSearchValues[col.key] || ''"
                    (ngModelChange)="onTextSearchInput(col.key, $event)"
                    (click)="$event.stopPropagation()"
                    autocomplete="off"
                    autofocus />
                  @if (hasActiveTextSearch(col.key)) {
                    <button type="button" class="ml-2 text-text-secondary hover:text-text-primary transition-colors flex-shrink-0"
                      (click)="clearTextSearch(col.key, $event)" title="Limpiar búsqueda">
                      <i class="fi fi-rr-cross-small text-[16px]"></i>
                    </button>
                  }
                </div>
              </div>
            }

            @if (col.columnType === 'multiSelectFilter' && openMultiSelectFilter === col.key) {
              <searchable-dropdown
                [dropdownId]="'multi-select-' + col.key"
                [options]="multiSelectFilterOptions[col.key] || []"
                [selectedOptions]="multiSelectSelectedOptions[col.key] || []"
                [multiSelect]="true"
                [autoOpen]="false"
                [hideTrigger]="true"
                [attachToBody]="false"
                [loading]="filterOptionsLoading"
                (multiSelectChanged)="onMultiSelectChange(col.key, $event)"
                (inputChanged)="onFilterSearchInput(col.key, $event)"
                class="absolute top-full left-0 mt-1 z-[100]">
              </searchable-dropdown>
            }
          </div>
        </th>
        }

        @if (icon1 || icon2 || showToggle) {
        <th
          class="px-4 py-2 font-semibold text-[14px] text-text-primary whitespace-nowrap select-none sticky right-0 bg-light z-20"
          [ngClass]="{ 'shadow-left': showColumnShadow }">
          Acciones
        </th>
        }
      </tr>
    </thead>
    <tbody>
      <!-- Filas con datos -->
      @if (paginatedData.length > 0) {
      @for (row of paginatedData; track row.id || $index; let i = $index) {
      <tr class="whitespace-nowrap odd:bg-stepper-active-num even:bg-light hover:bg-[#E1E5FF] group h-[52px]"
        [ngClass]="getRowCursorStyle()" (click)="onRowClick(row, $event)" (mouseenter)="onRowMouseEnter()"
        (mouseleave)="onRowMouseLeave()" (mousemove)="onRowMouseMove($event, row)">
        @for (col of columns; track col.key; let j = $index) {
        <td class="px-4 py-2 overflow-hidden text-ellipsis whitespace-nowrap" 
            [class]="col.cellClass || ''"
            [ngClass]="{
              'min-w-[100px]': j === 0,
              'min-w-[150px] max-w-[200px]': j !== 0,
              'font-medium text-[14px]  text-text-primary': j === 0 && isFirstColumnDark,
              'font-normal text-[12px] text-text-primary': j !== 0 || !isFirstColumnDark
            }">
          <div class="truncate" [ngClass]="col.contentClass || ''">
          @switch (col.type) {
          @case ('chip') {
          <span class="inline-block px-3 py-1 rounded-full text-xs font-medium" [ngClass]="{
          'bg-chip-green text-text-primary': (row[col.key]).toLowerCase() === 'activo',
          'bg-chip-red text-text-primary': (row[col.key]).toLowerCase() === 'inactivo',
          'bg-chip-orange text-text-primary': (row[col.key]).toLowerCase() === 'suspendido',
          'bg-gray-200 text-text-primary': (row[col.key]).toLowerCase() === 'eliminado',
          'bg-chip-yellow text-text-primary': ['pendiente', 'pago pendiente'].includes((row[col.key]).toLowerCase()),
          'bg-secundary-b1200 text-text-primary': ['borrador', 'test'].includes((row[col.key]).toLowerCase())
              }">
            {{ row[col.key] }}
          </span>
          }
          @case ('chipCustomStyle') {
          @if (chipStyleClasses && chipStyleClasses[(row[col.key]).toLowerCase()]) {
          <span class="inline-block px-3 py-1 rounded-full text-xs font-medium {{ chipStyleClasses[(row[col.key]).toLowerCase()] }}">
            {{ row[col.key] }}
          </span>
          } @else {
          <span class="inline-block px-3 py-1 rounded-full text-xs font-medium">
            {{ row[col.key] }}
          </span>
          }
          }
          @case ('card') {
          <div class="flex items-center gap-2">
            <img [src]="row[col.key]?.foto" alt="foto" class="w-8 h-8 rounded-full object-cover" />
            <span class="text-sm font-medium text-text-primary">
              {{ row[col.key]?.nombre }}
            </span>
          </div>
          }
          @case ('check') {
          <div class="flex items-center">
            <input type="radio" name="radio-{{ col.key }}" class="h-4 w-4 rounded-full cursor-pointer appearance-none
                       border border-gray
                     checked:bg-stepper-active-num checked:border-green-600 checked:border-4
                       focus:outline-none focus:ring-0" [checked]="row[col.key]" (change)="toggleRow(row)" />
          </div>
          }
          @case ('toggle') {
          <div class="flex items-center justify-center">
            <ng-container *ngTemplateOutlet="toggleTemplate; context: { $implicit: row }">
            </ng-container>
          </div>
          }
          @case ('circle') {
          <div class="w-4 h-4 rounded-full" [ngClass]="{
                     'bg-success': (row[col.key]).toLowerCase() === 'success',
                     'bg-error': (row[col.key]).toLowerCase() === 'error',
                     'bg-warning': (row[col.key]).toLowerCase() === 'warning'
                   }"></div>
          }
          @case ('list') {
          <div class="items-center gap-2">
            @for (item of row[col.data]; track $index; let k = $index) {
            <div class="flex items-center gap-2 mb-1">
              <div class="w-4 h-4 rounded-full" [ngClass]="{
                          'bg-success': (item.trafficLightType).toLowerCase() === 'green',
                          'bg-error': (item.trafficLightType).toLowerCase() === 'red',
                          'bg-warning': (item.trafficLightType).toLowerCase() === 'orange',
                          'bg-gray': (item.trafficLightType).toLowerCase() === 'gray'
                        }"></div>
              <span class="text-sm font-medium text-text-primary">
                {{ item.percentage }}%
              </span>

            </div>
            }
          </div>


          }
          @default {
          {{ row[col.key] }}
          }
          }
          </div>
        </td>
        }
        @if (icon1 || icon2 || showToggle) {
        <td class="px-4 py-0 text-center sticky right-0 z-10 group-hover:!bg-[#E1E5FF] w-[120px]" [ngClass]="{
              'bg-stepper-active-num': i % 2 === 0,
              'bg-light': i % 2 === 1,
              'shadow-left': showColumnShadow
            }">
          <div class="flex items-center justify-center gap-2 h-[52px]" (mouseenter)="onActionsMouseEnter()"
            (mouseleave)="onActionsMouseLeave()">
            @if (shouldShowIcon1ForRow(row)) {
            <button class="flex items-center justify-center px-2 text-[16px] leading-[0px]" (click)="iconAction1.emit(row)"
              [disabled]="validateIcon(row) || row.icon1IsLoading || row.isEditDisabled && icon1.includes('edit')">
              @if(row.icon1IsLoading){
              <div class="spinner w-5 h-5 border border-soft-gray border-t-transparent rounded-full"></div>
              }@else{
              <i class="{{ icon1 }}" [ngClass]="{
                    'text-text-secondary': validateIcon(row) || row.icon1IsLoading || (row.isEditDisabled && icon1.includes('edit')),
                    'text-text-primary': !validateIcon(row) && !row.icon1IsLoading && !(row.isEditDisabled && icon1.includes('edit'))
                  }">
              </i>}
            </button>
            }
            @if (icon3) {
            <button class="flex items-center justify-center px-2 text-[16px] leading-[0px]" (click)="iconAction3.emit(row)"
              [disabled]="validateIcon3(row) || (row.isEditDisabled && icon3.includes('refresh'))">
              <i class="{{ icon3 }}" [ngClass]="{
                'text-text-primary': !validateIcon3(row) || (!(row.isEditDisabled && icon3.includes('refresh'))),
                'text-text-secondary': validateIcon3(row) || (row.isEditDisabled && icon3.includes('refresh'))
              }">
              </i>
            </button>
            }
            @if (icon2) {
            <button class="flex items-center justify-center px-2 text-[16px] leading-[0px]" (click)="iconAction2.emit(row)"
              [disabled]="validateIcon2(row) || (row.isEditDisabled && icon2.includes('edit'))">
              <i class="{{ icon2 }}" [ngClass]="{
                'text-text-primary': !validateIcon2(row) || (!(row.isEditDisabled && icon2.includes('edit'))),
                'text-text-secondary': validateIcon2(row) || (row.isEditDisabled && icon2.includes('edit'))
              }">
              </i>
            </button>
            }
            @if (showToggle) {
            <ng-container *ngTemplateOutlet="toggleTemplate; context: { $implicit: row }">
            </ng-container>
            }
          </div>
        </td>
        }
      </tr>
      }
      <!-- Filas vacías -->
      @for (empty of emptyRows; track $index; let j = $index) {
      <tr class="whitespace-nowrap odd:bg-stepper-active-num even:bg-light h-[52px]">
        @for (col of columns; track col.key) {
        <td class="px-4 py-2 text-sm align-middle"></td>
        }
        @if (icon1 || icon2 || showToggle) {
        <td class="px-4 py-2 text-center sticky right-0 z-10 align-middle"
          [ngClass]="{ 'shadow-left': showColumnShadow }"></td>
        }
      </tr>
      }}
      <!-- Mensaje sin datos -->
      @if (paginatedData.length === 0) {
      <tr [style.height.px]="emptyRows.length * 52">
        <td [attr.colspan]="columns.length + (icon1 || icon2 || showToggle ? 1 : 0)" class="text-center text-gray-500">
          <div class="flex items-center justify-center h-full">
            {{ resultsNotFoundText }}
          </div>
        </td>
      </tr>
      }
    </tbody>
  </table>
  </div>
  
  <!-- Dropdown de filtro de fecha -->
  @if (openDateFilter) {
    <div class="absolute z-[99999]" 
         [style.top.px]="dateFilterPosition.top"
         [style.left.px]="dateFilterPosition.left">
      <app-dropdown-date
        [dropdownId]="'date-filter-' + openDateFilter"
        [hideTrigger]="true"
        [initialStartDate]="dateFilters[openDateFilter]?.start"
        [initialEndDate]="dateFilters[openDateFilter]?.end"
        (dateRangeSelected)="onDateRangeSelected(openDateFilter, $event)"
        (dateRangeCleared)="onDateRangeCleared(openDateFilter)">
      </app-dropdown-date>
    </div>
  }
  
  <!-- Tooltip flotante para filas -->
  @if (rowTooltipVisible && rowTooltipText) {
  <div
    class="fixed z-[9999] rounded-xl py-2 px-4 text-xs font-medium text-[#F6F8FB] bg-[#1A212B] pointer-events-none -translate-x-1/2"
    [ngClass]="{'whitespace-nowrap': rowTooltipText.length < 50, 'whitespace-normal max-w-[300px]': rowTooltipText.length >= 50}"
    [style.left.px]="rowTooltipX" [style.top.px]="rowTooltipY">
    {{ rowTooltipText }}
  </div>
  }
</div>

<ng-template #toggleTemplate let-row>
  <button type="button" (click)="toggleRow(row)" [attr.aria-pressed]="row.toggleActive ? 'true' : 'false'"
    [disabled]="row.toggleIsDisabled || row.isToggleDisabled"
    class="relative inline-flex w-10 h-6 items-center rounded-full transition-colors duration-300 focus:outline-none"
    [ngClass]="{
          'bg-primary-g500': row.toggleActive,
          'bg-transparent border border-soft-gray opacity-50': row.toggleIsDisabled,
          'bg-transparent border border-soft-gray': !row.toggleActive
        }">
    <span class="absolute left-1 top-1 w-4 h-4 rounded-full shadow-sm transition-transform duration-300" [ngClass]="{
            'translate-x-4 bg-light': row.toggleActive,
            'translate-x-0 -translate-y-[1px] bg-gray': !row.toggleActive
          }"></span>
  </button>
</ng-template>
